import { render, staticRenderFns } from "./UnitSmallCode.vue?vue&type=template&id=5387f1b3&scoped=true"
import script from "./UnitSmallCode.vue?vue&type=script&lang=js"
export * from "./UnitSmallCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5387f1b3",
  null
  
)

export default component.exports